import React from "react";

const apiBaseUrl = process.env.REACT_APP_URL_LOCAL || "";

const getInitials = (name) => {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
};

const sizeMap = {
  sm: "size-8",
  md: "size-10",
  lg: "size-12",
  AdminCards: "size-10 sm:size-16 lg:size-24",
};

const UserAvatar = ({ user, src, alt, name, size = "md", className = "" }) => {
  const resolvedName = name || user?.Surnom || alt || "";
  const resolvedSrc = src || (user?.CheminImage ? `${apiBaseUrl}${user.CheminImage}` : "");
  const avatarSizeClass = className || `${sizeMap[size] || sizeMap.md} rounded-md object-cover`;

  if (resolvedSrc) {
    return (
      <img
        alt={alt || resolvedName || "Utilisateur"}
        src={resolvedSrc}
        className={`${avatarSizeClass} bg-slate-800 outline outline-1 -outline-offset-1 outline-black/5 dark:outline-white/10`}
      />
    );
  }

  return (
    <span
      className={`${avatarSizeClass} inline-flex items-center justify-center bg-slate-700 text-sm font-semibold text-slate-100 outline outline-1 -outline-offset-1 outline-black/5 dark:outline-white/10`}
    >
      {getInitials(resolvedName)}
    </span>
  );
};

export default UserAvatar;
